import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EcommerceRoutingModule } from './ecommerce-routing.module';

import { EcommerceLayoutComponent } from './ecommerce-layout/ecommerce-layout.component';
import { EcommerceDashboaardComponent } from './ecommerce-dashboaard/ecommerce-dashboaard.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CustomMaterialModule } from '../custom-material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ShareModule } from '../_share/share.module';

import { OrdersComponent } from './orders/orders.component';
import { OrderDetailsComponent } from './order-details/order-details.component';
import { OrderTrackingComponent } from './order-tracking/order-tracking.component';
import { OrderProcessComponent } from './order-process/order-process.component';
import { ProductCreateComponent } from './Product/product-create/product-create.component';
import { CategoryCreateComponent } from './Product/category-create/category-create.component';
import { BrandCreateComponent } from './Product/brand-create/brand-create.component';
import { ProductEditComponent, KeyHighlightsCreateComponent, ProductReviewCreateComponent } from './Product/product-edit/product-edit.component';
import { ProductListComponent } from './Product/product-list/product-list.component';
import { BrandEditComponent } from './Product/brand-edit/brand-edit.component';
import { CategoryEditComponent } from './Product/category-edit/category-edit.component';
import { CategoriesComponent } from './Product/categories/categories.component';
import { BrandsComponent } from './Product/brands/brands.component';
import { AttributesComponent } from './Product/attributes/attributes.component';
import { CategoryTreeComponent } from './Product/category-tree/category-tree.component';
import { OrderAssignedForDeliveryComponent } from './order-assigned-for-delivery/order-assigned-for-delivery.component';
import { OrderEditComponent } from './order-edit/order-edit.component';
import { GenerateBillComponent } from './generate-bill/generate-bill.component';
import { DeliveryProcessComponent } from './delivery-process/delivery-process.component';
//import { DragDropModule } from '@angular/cdk/drag-drop';
// import { ColorCreateComponent } from './Product/color-create/color-create.component';
import { ProductSizeComponent, ProductSizeDialogComponent, SizeChartCreateComponent } from './Product/product-size/product-size.component';
import { ProductColorsComponent, CreateColorComponent } from './Product/product-colors/product-colors.component';
import { GeneralSettingsComponent } from './Ecomsettings/general-settings/general-settings.component';
import { CouponsComponent, CouponCreateComponent } from './coupons/coupons.component';
import { CustomersComponent } from './customers/customers.component';
import { ReturnOrdersComponent } from './return-orders/return-orders.component';
import { SeoMetadataComponent } from './Product/seo-metadata/seo-metadata.component';
import { PagesComponent, PageCreateComponent } from './pages/pages.component';
import { ShippedOrdersComponent } from './shipped-orders/shipped-orders.component';
import { CustomerPanelComponent } from './customer-panel/customer-panel.component';
import { BannarsComponent, ImageCreateComponent } from './Cms/bannars/bannars.component';
import { OutletsComponent } from './outlets/outlets.component';
import { MatButtonModule, MatCardModule, MatGridListModule, MatIconModule, MatInputModule, MatToolbarModule } from '@angular/material';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { GlobalContentComponent } from './Cms/global-content/global-content.component';


@NgModule({
  declarations: [
    EcommerceLayoutComponent,
    EcommerceDashboaardComponent,
    BrandsComponent,
    CategoriesComponent,
    AttributesComponent,
    OrdersComponent,
    OrderDetailsComponent,
    OrderTrackingComponent,
    OrderProcessComponent,
    ProductSizeComponent, ProductSizeDialogComponent, SizeChartCreateComponent,
    ProductCreateComponent,
    ProductColorsComponent, CreateColorComponent,
    CategoryEditComponent,
    CategoryCreateComponent,
    BrandEditComponent,
    BrandCreateComponent,
    ProductEditComponent, KeyHighlightsCreateComponent, ProductReviewCreateComponent,
    ProductListComponent,
    CategoryTreeComponent,
    OrderAssignedForDeliveryComponent,
    OrderEditComponent,
    GenerateBillComponent,
    DeliveryProcessComponent,
    GeneralSettingsComponent,
    CouponsComponent, CouponCreateComponent, CustomersComponent, ReturnOrdersComponent, SeoMetadataComponent,
    PagesComponent, PageCreateComponent, ShippedOrdersComponent, CustomerPanelComponent,
    BannarsComponent, ImageCreateComponent, OutletsComponent, GlobalContentComponent
    // ColorCreateComponent,
    //DragDropModule, // Import DragDropModule
  ],
  imports: [
    CommonModule,
    FlexLayoutModule,
    CustomMaterialModule,
    ReactiveFormsModule, FormsModule,
    EcommerceRoutingModule,
    ShareModule,

    MatToolbarModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatGridListModule,

    BrowserModule,
    BrowserAnimationsModule

  ],
  entryComponents: [
    CategoryCreateComponent,
    CategoryEditComponent,
    BrandCreateComponent,
    BrandEditComponent,
    OrderEditComponent,
    // ColorCreateComponent,
    CreateColorComponent,
    CouponCreateComponent,
    ProductSizeDialogComponent,
    KeyHighlightsCreateComponent, ProductReviewCreateComponent,
    CustomerPanelComponent,
    SizeChartCreateComponent, PageCreateComponent,
    ImageCreateComponent
  ]
})
export class EcommerceModule { }
